const timeline = {
  filters: {
    status: {
      placeholder: 'Estado',
      options: {
        'new': 'Nuevo',
        'in-route': 'En ruta',
        'sent': 'Enviado',
        'approved': 'Aprobado',
        'done': 'Listo',
        'canceled': 'Cancelado',
        'picking_up': 'Recogida',
      },
    },
    driver: 'Conductor',
    vehicle: 'Vehículo',
    areas: 'Zonas',
    locations: 'Ubicaciones',
    airportLocations: 'Ubicaciones de Aeropuerto',
    driverShifts: 'Mostrar turnos de conductor',
    showUnassignedTrips: 'Mostrar viajes no asignados',
  },
  alerts: {
    etaChanged:
      'El tiempo estimado de llegada a las paradas {{stopsIds}} del viaje {{tripId}} fue actualizado: el sistema notificó al conductor.',
  },
  assigenModal: {
    header: 'Asignar conductor',
    description: 'Seleccione un conductor o vehículo de la lista a continuación',
    driver: 'Elija conductor',
    vehicle: 'Elija Vehículo',
    button: 'Asignar',
  },
  toast: {
    toastSomethingWasWrong: 'Algo salió mal',
    assignedTrips: 'Se han asignado {{numOfTrips}} viajes',
  },
  empty: 'No hay viajes en las últimas 24 horas',
  driverInfo: {
    phoneNumber: 'NÚMERO DE TELÉFONO',
    lettersLeft: 'Letras a la izquierda',
    sendMessage: 'Enviar mensaje',
  },
  actions: {
    manualAssign: 'Asignación manual',
    removeAssign: 'Eliminar asignación',
    assignInsights: 'Asignar información',
  },
  tripInformation: {
    trip: 'Viaje #{{id}}',
  },
  stopInfo: {
    stopNumber: 'Parada #{{number}}',
    tripId: 'Viaje: {{id}}',
    pta: 'PTA: {{pta}}',
    eta: 'ETA: {{eta}}',
    totalReservations: '{{count}} reservas',
    pickupReservations: '{{count}} recogidas',
    dropReservations: '{{count}} descensos',
    totalSeats: '{{count}} asientos',
    table: {
      header: {
        reqAppt: 'Sol./Cita',
        passenger: 'Pasajero',
        bookingId: 'ID de reserva',
        seats: 'Asientos',
        zones: 'Zonas',
        attributes: 'Atributos',
      },
      sections: {
        pickups: 'RECOGIDAS',
        dropoffs: 'DESCENSOS',
        request: 'Solicitud',
        appt: 'Cita',
      },
    },
  },
};

export default timeline;
